import React from 'react';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Header } from 'shared/components/header';

import {
  BreadcrumbContainer,
  BreadcrumbLink,
  BreadcrumbText,
  ContentContainer,
  PageWrapper,
  TextBody,
  Title,
} from './styles';
import { Box } from '@mui/material';
export const TermsPage: React.FC = () => {
  return (
    <Box>
      <Header />
      <PageWrapper>
        <BreadcrumbContainer>
          <BreadcrumbLink href="/">Início</BreadcrumbLink>
          <ChevronRightIcon sx={{ fontSize: 16, color: '#0e77da' }} />
          <BreadcrumbText>Termo de uso</BreadcrumbText>
        </BreadcrumbContainer>

        <ContentContainer>
          <Title>Termo de uso</Title>
          <TextBody>
            <div>
              Bem-vindo aos Termos de Uso da plataforma de financiamento Dimo da Motorola. Ao utilizar nossos serviços,
              você concorda com os seguintes termos:
            </div>
            <div>
              1. ACEITAÇÃO DOS TERMOS <br />
              Ao acessar e usar esta plataforma, você aceita e concorda em ficar vinculado aos termos e condições deste
              acordo. Se você não concordar com qualquer parte destes termos, não deverá usar nossos serviços.
            </div>
            <div>
              {' '}
              2. USO DO SERVIÇO <br />
              Você concorda em usar o serviço apenas para fins legais e de acordo com todas as leis aplicáveis. É
              proibido: (i) usar a plataforma para qualquer finalidade ilegal ou não autorizada; (ii) tentar interferir
              no funcionamento adequado da plataforma; (iii) fornecer informações falsas ou enganosas.
            </div>
            <div>
              3. PRIVACIDADE E PROTEÇÃO DE DADOS <br />
              Seus dados pessoais serão tratados conforme nossa Política de Privacidade, em total conformidade com a
              LGPD (Lei Geral de Proteção de Dados - Lei nº 13.709/2018). Coletamos apenas os dados necessários para
              processar sua solicitação de financiamento.
            </div>
            <div>
              4. MODIFICAÇÕESS <br />
              Reservamo-nos o direito de modificar estes termos a qualquer momento. Você será notificado sobre quaisquer
              alterações materiais através do e-mail cadastrado ou por meio de aviso na plataforma.
            </div>
            <div>
              5. LIMITAÇÃO DE RESPONSABILIDADE <br />
              Em nenhuma circunstância a Motorola ou o Banco Arbi S/A serão responsáveis por danos indiretos,
              incidentais, especiais, consequenciais ou punitivos relacionados ao uso desta plataforma.
            </div>
            <div>
              6. LEI APLICÁVEL <br />
              Estes termos serão regidos e interpretados de acordo com as leis da República Federativa do Brasil.
              Qualquer disputa será submetida ao foro da comarca de domicílio do consumidor.
            </div>
            Para dúvidas ou mais informações, entre em contato através dos nossos canais de atendimento.
          </TextBody>
        </ContentContainer>
      </PageWrapper>
    </Box>
  );
};
